var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { ChangeEventListener, TransferEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
class BaseFileUploaderAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /** @event */
        this.onAbort = new TransferEventListener();
        /** @event */
        this.onChange = new ChangeEventListener();
        /** @event */
        this.onCompleted = new TransferEventListener();
        /** @event */
        this.onError = new TransferEventListener();
        /** @event */
        this.onInvalid = new TransferEventListener();
        /** @event */
        this.onPreview = new TransferEventListener();
        /** @event */
        this.onRemove = new TransferEventListener();
        /** @event */
        this.onRetry = new TransferEventListener();
        /** @event */
        this.onUpload = new TransferEventListener();
    }
    /**
    * Returns the browse file expression.
    */
    getBrowseFileExpression() {
        return this.state.browseFileExpression;
    }
    /**
     * Sets the browse file expression.
     *
     * @param browseFileExpression - The browse file expression.
     */
    setBrowseFileExpression(browseFileExpression) {
        this.setState({ ...this.state, browseFileExpression });
    }
    /**
     * Returns the file uploader modal properties.
     */
    getModalProps() {
        return this.state.modalProps;
    }
    /**
     * Sets the file uploader modal properties.
     *
     * @param modalProps - The file uploader modal properties.
     */
    setModalProps(modalProps) {
        this.setState({ ...this.state, modalProps });
    }
    /**
     * Returns the failed upload expression.
     */
    getFailedUploadExpression() {
        return this.state.failedUploadExpression;
    }
    /**
     * Sets the failed upload expression.
     *
     * @param failedUploadExpression - The failed upload expression.
     */
    setFailedUploadExpression(failedUploadExpression) {
        this.setState({ ...this.state, failedUploadExpression });
    }
    /**
     * Returns the predefined files.
     */
    getPredefinedFiles() {
        return this.state.predefinedFiles;
    }
    /**
     * Sets the predefined files.
     *
     * @param predefinedFiles - The predefined files.
     */
    setPredefinedFiles(predefinedFiles) {
        this.setState({ ...this.state, predefinedFiles });
    }
    /**
     * Returns file uploader the value.
     */
    getValue() {
        return this.state.value;
    }
    /**
     * Sets the file uploader value.
     *
     * @param value - The file uploader value.
     */
    setValue(value) {
        this.setState({ ...this.state, value });
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], BaseFileUploaderAPI.prototype, "onAbort", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], BaseFileUploaderAPI.prototype, "onChange", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], BaseFileUploaderAPI.prototype, "onCompleted", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], BaseFileUploaderAPI.prototype, "onError", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], BaseFileUploaderAPI.prototype, "onInvalid", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], BaseFileUploaderAPI.prototype, "onPreview", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], BaseFileUploaderAPI.prototype, "onRemove", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], BaseFileUploaderAPI.prototype, "onRetry", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], BaseFileUploaderAPI.prototype, "onUpload", void 0);
export { BaseFileUploaderAPI, };
//# sourceMappingURL=base-file-uploader-api.js.map